import React, { useState } from 'react';

export default function ContactUs() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setError('Please fill in all required fields.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    // In a real app, you would send this to your backend
    setSubmitted(true);
  }

  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '860px', padding: '3rem 2rem' }}>
        <div className="page-header">
          <h1>Contact Us</h1>
          <p>We'd love to hear from you</p>
        </div>

        <div className="static-content">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info-panel">
              <h2>Get in Touch</h2>
              <p>
                Have a question about your reading, need technical support, or want to share
                feedback? We're here to help. Reach out to us and we'll respond within 24–48 hours.
              </p>

              <div className="contact-info-items">
                <div className="contact-info-item">
                  <span className="contact-icon">📧</span>
                  <div>
                    <h3>Email</h3>
                    <a href="mailto:support@astroa2z.com">support@astroa2z.com</a>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-icon">🕐</span>
                  <div>
                    <h3>Response Time</h3>
                    <p>Within 24–48 hours</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-icon">🌐</span>
                  <div>
                    <h3>Social Media</h3>
                    <p>Follow us for daily horoscopes and updates</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-panel">
              {submitted ? (
                <div className="contact-success">
                  <span style={{ fontSize: '3rem' }}>✅</span>
                  <h2>Message Sent!</h2>
                  <p>
                    Thank you for reaching out. We'll get back to you at <strong>{form.email}</strong> within
                    24–48 hours.
                  </p>
                  <button
                    className="btn btn-primary"
                    style={{ marginTop: '1rem' }}
                    onClick={() => { setSubmitted(false); setForm({ name: '', email: '', subject: '', message: '' }); }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit} noValidate>
                  <h2>Send a Message</h2>

                  {error && <div className="error-message">{error}</div>}

                  <div className="form-group">
                    <label htmlFor="name">Name <span className="required">*</span></label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Your full name"
                      maxLength={100}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email <span className="required">*</span></label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      maxLength={200}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={form.subject}
                      onChange={handleChange}
                      placeholder="What's this about?"
                      maxLength={200}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message <span className="required">*</span></label>
                    <textarea
                      id="message"
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Tell us how we can help..."
                      rows={5}
                      maxLength={2000}
                      required
                    />
                  </div>

                  <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                    Send Message ✨
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
